export default __webpack_public_path__ + "static/media/drip.6e7e21e6.png";